export class DynamoDbIndexKeySchemaElement {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "name",
            "baseName": "name",
            "type": "string",
            "format": ""
        },
        {
            "name": "type",
            "baseName": "type",
            "type": "DynamoDbKeyType",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return DynamoDbIndexKeySchemaElement.attributeTypeMap;
    }
    constructor() {
    }
}
